import { environment } from '../environments/environment';
import { AppType } from '../model/app-type.model';
import { StepConfig } from '../model/step-config.model';
import { STEPS_AGENT_CONFIG } from './step-agent.config';
import { STEPS_DIRECT_CONFIG } from './step-direct.config';
import { STEPS_TRAVEL_AGENCY_CONFIG } from './step-travel-agency.config';

export const STEPS_CONFIG = (): StepConfig => {
  switch (environment.app) {
    case AppType.Agent:
      return STEPS_AGENT_CONFIG;
    case AppType.Direct:
      return STEPS_DIRECT_CONFIG;
    case AppType.TravelAgency:
      return STEPS_TRAVEL_AGENCY_CONFIG;
  }
};
